export const EMAIL_VARIABLES_VIEW_LIST_TEXT = {
    id: 'oe.emails.viewVariablesList',
    defaultMessage: 'View Variables',
    description: 'Popover header text'
};

export const EMAIL_VARIABLES_VIEW_LIST_TITLE_TEXT = {
    id: 'oe.emails.viewVariablesListTitle',
    defaultMessage: 'Library of variables for Email Subject and Body',
    description: 'Label text'
};

export const EMAIL_VARIABLES_LOADING_TEXT = {
    id: 'oe.common.loadingEmailVariables',
    defaultMessage: 'Loading email variables...',
    description: 'text'
};